angular.module 'app'
.controller 'VerifySuccessController', ($timeout, $stateParams, $scope, $http, $state, $ionicPopup, config, activeUser, ionicMaterialInk) ->
  if _.isUndefined activeUser.user.openid
    $state.go('focus_on', {wechat_id: activeUser.wechat_id})
  $scope.ui =
    baseUrl: config.api.baseUrl
    status: $stateParams.status
    homepage: activeUser.homepage
    userInfo: activeUser.user
    isHide: false
    isInput: false
    student: {}
    students: []

  $scope.toCheck = ->
    $scope.ui.isHide = false
    $scope.ui.isInput = false

  do findParent = ->
    if $stateParams.status is 'parent'
      $http.get "#{config.api.baseUrl}/cumpus/student",
        params:
          parent_openid: activeUser.user.openid
          group_id: activeUser.group_id
      .then (res) ->
        $scope.ui.students = res.data.data
        $timeout (->
          ionicMaterialInk.displayEffect()
        ), 1000
      .catch (error) ->

  do findStudent = ->
    if $stateParams.status is 'student'
      $http.get "#{config.api.baseUrl}/cumpus/student/#{$stateParams.user_id}",
        params:
          openid: activeUser.user.openid
          group_id: activeUser.group_id
      .then (res) ->
        $scope.ui.student = res.data
        $timeout (->
          ionicMaterialInk.displayEffect()
        ), 1000
      .catch (error) ->

  $scope.toAuthenticationInfo = ->
    $state.go("app.authentication_info", {status: '1'})

  $scope.delParent = (student) ->
    confirmPopup = $ionicPopup.confirm(
      title: "解除驗證"
      template: "您确定解除“學號：#{student.student_num}，年級：#{student.student_grade}，班級：#{student.student_class}”的驗證吗?"
      buttons: [
          text: '<b>取消</b>'
          type: 'button-light'
        ,
          text: '<b>确定</b>'
          type: 'button-positive'
          onTap: (e) ->
            doRemoveParent(student)
      ]
    )


  $scope.deauthentication = ->
    if $stateParams.status is 'parent'
      confirmPopup = $ionicPopup.confirm(
        title: "解除驗證"
        template: "您确定解除全部驗證吗?"
        buttons: [
            text: '<b>取消</b>'
            type: 'button-light'
          ,
            text: '<b>確定</b>'
            type: 'button-positive'
            onTap: (e) ->
              doRemoveParents()
        ]
      )
    else
      confirmPopup = $ionicPopup.confirm(
        title: "解除驗證"
        template: "您确定解除驗證吗?"
        buttons: [
            text: '<b>取消</b>'
            type: 'button-light'
          ,
            text: '<b>確定</b>'
            type: 'button-positive'
            onTap: (e) ->
              doRemoveStudent()
        ]
      )

  doRemoveParent = (student) ->
    _.each student.parents, (parent, index) ->
      student.parents.splice index, 1 if parent.openid is activeUser.user.openid
    $http.put "#{config.api.baseUrl}/cumpus/student/#{student._id}", {parents: student.parents}
    .then (res) ->
      findParent()
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "解除驗證失敗！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  doRemoveParents = ->
    $http.delete "#{config.api.baseUrl}/cumpus/certification/parents?openid=#{activeUser.user.openid}", {}
    .then (res) ->
      $state.go("app.authentication_info", {status: '1'})
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "解除驗證失敗！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  doRemoveStudent = ->
    $http.put "#{config.api.baseUrl}/cumpus/student/#{$stateParams.user_id}", {openid: ''}
    .then (res) ->
      $state.go("app.authentication_info", {status: '1'})
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "解除驗證失敗！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )
